var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.806,
    height: 16.495,
    viewBox: "0 0 15.806 16.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e11e5a;stroke:#fff;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.066,4.755h-4.2A2.82,2.82,0,0,0,12.086,2.4h-.05A2.82,2.82,0,0,0,9.261,4.755h-4.2a.656.656,0,0,0,0,1.312h.959v9.486A2.828,2.828,0,0,0,8.857,18.4h6.358a2.828,2.828,0,0,0,2.842-2.842V6.067h.992a.646.646,0,0,0,.656-.656A.632.632,0,0,0,19.066,4.755ZM12.053,3.712h.05a1.489,1.489,0,0,1,1.43,1.043H10.606A1.51,1.51,0,0,1,12.053,3.712ZM16.8,15.57A1.515,1.515,0,0,1,15.265,17.1H8.874A1.515,1.515,0,0,1,7.343,15.57v-9.5h9.436v9.486H16.8Z",
    transform: "translate(-4.4 -2.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.956,44.044a.646.646,0,0,0,.656-.656V38.056a.656.656,0,1,0-1.312,0v5.332A.646.646,0,0,0,34.956,44.044Z",
    transform: "translate(-29.271 -31.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.556,44.044a.646.646,0,0,0,.656-.656V38.056a.656.656,0,1,0-1.312,0v5.332A.668.668,0,0,0,58.556,44.044Z",
    transform: "translate(-48.902 -31.513)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1b36b81a1a269456ca516aead2f60c82.svg";
export { ForwardRef as ReactComponent };